import Swiper from 'swiper'; 
import { EffectFade, Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {

    
    const swiperSlider = () => {
        const slider = document.querySelector('.slider-block .swiper');
        if (!slider) return;

        const dataAutoPlay = document.querySelector('.slider-block .swiper').dataset.autoplay;

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            effect: 'fade',
            modules: [EffectFade, Pagination, Navigation, Autoplay],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: dataAutoPlay === 'true' ? {
                delay: 5000,
                pauseOnMouseEnter: true,
            } : false,
        });

        let previousIndex = swiper.activeIndex;

        swiper.on('slideChangeTransitionStart', () => {
            const currentIndex = swiper.activeIndex;
            const direction = currentIndex > previousIndex ? 'right' : 'left';

            swiper.slides.forEach((slide) => {
                slide.querySelectorAll('.content, .image').forEach((el) => {
                    el.classList.remove('fadeInLeft', 'fadeInRight');
                });
            });

            const currentSlide = swiper.slides[currentIndex];
            if (currentSlide) {
                currentSlide.querySelectorAll('.content, .image').forEach((el) => {
                    el.classList.add(direction === 'right' ? 'fadeInRight' : 'fadeInLeft');
                });
            }

            previousIndex = currentIndex;
        });

        swiper.on('slideChangeTransitionEnd', () => {
            swiper.slides.forEach((slide) => {
                slide.querySelectorAll('.content, .image').forEach((el) => {
                    el.style.opacity = '1';
                });
            });
        });
    }

    swiperSlider();

});
